import * as types from './types';

export function setShopifyOrder(order) {
  return (dispatch) => {
    dispatch({
      type: types.SET_SHOPIFYORDER_DATA,
      payload: order,
    });
  };
}
